






































































































































































































import Vue from "vue";
import { Header } from "../../MyTable.vue";
import InfoCard from "@/components/SpaceOverview/InfoCard.vue";
import { axios } from "../../../plugins";
import { uuid } from "@/utils/uuid";

const nodeHeader: Header[] = [
  { title: "名称", key: "type" },
  { title: "原因", key: "reason" },
  { title: "消息", key: "message" },
  { title: "最近更新时间", key: "lastTransitionTime" }
];
export default Vue.extend({
  name: "Overview",
  components: { InfoCard },
  props: {
    hostData: { type: Object }
  },
  data() {
    return {
      uuid: uuid(),
      loading: false,
      loading2: false,
      nodeHeader,
      detail: null as any,
      usage: null as any,
      color: [
        { color: "#23b065", percentage: 30 },
        { color: "#f0c000", percentage: 60 },
        { color: "#f14c47", percentage: 90 }
      ]
    };
  },

  mounted() {
    this.getDetail();
    this.getUsage();
  },

  methods: {
    getIp(addresses: any[]) {
      const data = addresses.find(item => item.type === "InternalIP");
      if (data) {
        return data.address;
      } else {
        return "-";
      }
    },
    getUsage() {
      this.loading = true;
      axios
        .get(`/monitor/hosts/${this.hostData.name}/usage`)
        .then(res => {
          this.usage = res.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDetail() {
      this.loading2 = true;

      axios
        .get(`/monitor/hosts/${this.hostData.name}/detail`)
        .then(res => {
          this.detail = res.data.data;
        })
        .finally(() => {
          this.loading2 = false;
        });
    }
  }
});
